export default __webpack_public_path__ + "static/media/asoulforourfeast5.206ad047.png";